import { graphql } from "@/lib/gql/__generated__/gql";

export const PAYMENT_CREDIT_MUTATION = graphql(/* GraphQL */ `
	mutation PaymentCreditMutation($input: PaymentCreditInput!) {
		paymentCreditUpdate(input: $input) {
			paymentCredit {
				expired
				id
				hotelID
				last4
			}
			userErrors
		}
	}
`);
